/* @flow */

type Settings = {
  width?: number,
  height?: number,
};

export function settingsForProvider(provider: string): Settings {
  // prettier-ignore
  switch (true) {
    case provider.startsWith('google'): return { width: 500, height: 600 };
    default:                            return { width: 800, height: 600 };
  }
}
